<table mat-table [dataSource]="dataSource" class="w-100">
  <ng-container matColumnDef="time">
    <th mat-header-cell *matHeaderCellDef>Time</th>
    <td mat-cell *matCellDef="let element">{{ slotTime(element.timeslot) }}</td>
  </ng-container>
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element" >
      @if (element.appointment) {
        <mat-checkbox class="appointment-select" (change)="onAppointmentSelectionChanged(selectBox.checked, element.appointment)" #selectBox ></mat-checkbox>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="patientStatus">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let element" >
      <div class="patient-status-holder" [style.background-color]="element.appointment?.patient?.status?.color"></div>
    </td>
  </ng-container>
  <ng-container matColumnDef="profileId">
    <th mat-header-cell *matHeaderCellDef class="d-responsive d-md">File No</th>
    <td mat-cell *matCellDef="let element" class="d-responsive d-md">{{element.appointment?.patient?.profileId}}</td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> Name. </th>
    <td mat-cell *matCellDef="let element">{{element.appointment?.title ?? (element.appointment?.patient | patientName: patientDisplayFormat)}}</td>
  </ng-container>
  <ng-container matColumnDef="cell">
    <th mat-header-cell *matHeaderCellDef class="d-responsive d-lg"> Cell No </th>
    <td mat-cell *matCellDef="let element" class="d-responsive d-lg">{{element.appointment?.patient?.cell  ?? element.appointment?.metaData?.cell ?? ''}}</td>
  </ng-container>
  <ng-container matColumnDef="identityNumber">
    <th mat-header-cell *matHeaderCellDef class="d-responsive d-lg"> ID No </th>
    <td mat-cell *matCellDef="let element" class="d-responsive d-lg">{{element.appointment?.patient?.identityNumber}}</td>
  </ng-container>
  <ng-container matColumnDef="reason">
    <th mat-header-cell *matHeaderCellDef class="d-responsive d-xl"> Reason </th>
    <td mat-cell *matCellDef="let element" class="d-responsive d-xl">{{element.appointment?.comment}}</td>
  </ng-container>
  <ng-container matColumnDef="appointmentStatus">
    <th mat-header-cell *matHeaderCellDef class="d-responsive d-xl"> Appt Status </th>
    <td mat-cell *matCellDef="let element" class="d-responsive d-xl">
      @if (element.appointment) {
        <div class="appointment-status-holder" [style.background-color]="element.appointment.appointmentType.displayStyle">{{element.appointment.appointmentType.title}}</div>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> Actions </th>
    <td mat-cell *matCellDef="let element">
      <button mat-icon-button (click)="addNewAppointment()" *xuiPermissionRequired="'Clinical.Patients.Read'; condition: !element.appointment && selectedRow === element">
        <mat-icon>add</mat-icon>
      </button>
      @if (element.appointment) {
        <div class="button-holder">
          <button mat-icon-button (click)="sendSingleMessage(element.appointment)" *xuiPermissionRequired="'Clinical.Messages.Write'">
            <mat-icon>sms</mat-icon>
          </button>
          <button mat-icon-button (click)="sendSingleEmail(element.appointment)" *xuiPermissionRequired="'Clinical.Emails.Write'">
            <mat-icon>email</mat-icon>
          </button>
          <button mat-icon-button (click)="editAppointment(element.appointment)" *xuiPermissionRequired="'Clinical.Appointments.Write'">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button *xuiPermissionRequired="'Clinical.Appointments.Delete'" (confirm)="removeAppointment(element.appointment)"
            xuiConfirmationDialog confirmTitle="Remove Appointment" confirmMessage="Are you sure you want to remove this appointment?">
            <mat-icon>delete</mat-icon>
          </button>
          <button mat-icon-button *xuiPermissionRequired="'Clinical.Patients.Read'; condition: element.appointment.appointmentType.isPatientAppointment && !!element.appointment.patient" (click)="view(element.appointment)">
            <mat-icon>open_in_new</mat-icon>
          </button>
          <button mat-icon-button *xuiPermissionRequired="'Clinical.Patients.Write'; condition: element.appointment.appointmentType.isPatientAppointment && !element.appointment.patient" (click)="createPatient(element.appointment)">
            <mat-icon>library_add</mat-icon>
          </button>
        </div>
      }
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
  <tr [class.row-selected]="row === selectedRow" mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"></tr>
</table>
